<template>
  <b-container fluid>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-form v-on:submit.prevent="buscar">
      <div class="row">
        <div class="col-12" v-if="$localStorageService.can('Com_01_cambio') && mostrarFiltroTodos">
          <b-form-checkbox v-model="filtro.todosEmpleados" switch >
            <Strong>¿Todos los empleados y clínicas?</Strong>
          </b-form-checkbox>
        </div>
        <div class="col-12">
            <div class="row">
              <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4" v-if="$localStorageService.can('C0_01_Com_ogs') && !filtro.todosEmpleados">
                <b-form-group align="left">
  
                  <label for="clinica">Empleado </label>
                  <validacion />
                  <b-form-select
                      name="clinica"
                      v-model="filtro.idEmpleado"
                      :options="empleados"
                      value-field="idEmpleado"
                      text-field="nombreDoctor"
                      :state="filtro.idEmpleado != null"
                      required
                  >
                  </b-form-select>
                  <b-form-invalid-feedback :state="filtro.idEmpleado != null">
                    Se debe seleccionar el empleado
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <b-form-group align="left">
                  <label for="nombreBusq">Año</label>
                  <validacion />
                  <b-form-select
                      name="nombreBusq"
                      v-model="filtro.anio"
                      :options="anios"
                      :state="filtro.anio != null"
                      required
                  >
                  </b-form-select>
                  <b-form-invalid-feedback :state="filtro.anio != null">
                    Se debe seleccionar el año
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <b-form-group align="left">
                  <label for="nombreBusq">Mes</label>
                  <validacion />
                  <b-form-select
                      name="nombreMes"
                      v-model="filtro.mes"
                      :options="meses"
                      :state="filtro.mes != null"
                      required
                  >
                  </b-form-select>
                  <b-form-invalid-feedback :state="filtro.mes != null">
                    Se debe seleccionar el mes
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>
        </div>
      </div>

      <div class="row">
          <div class="col-sm-6 col-md-4 col-lg-4 col-xl-4">
            <b-form-group align="left">
              <label>Periodo</label>
              <validacion />
              <b-form-radio v-if="tipoBusqueda !== 'mes'" v-model="filtro.periodo" name="some-radios" value="1" required>Quincenal</b-form-radio>
              <b-form-radio v-if="tipoBusqueda !== 'quincena'" v-model="filtro.periodo" name="some-radios" value="2" required>Mensual</b-form-radio>
              <b-form-invalid-feedback :state="filtro.periodo != null">
                Se debe seleccionar un periodo
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-sm-6 col-md-4 col-lg-4 col-xl-4">
            <b-form-group align="left" v-if="filtro.periodo === '1'" >
              <label>Quincena</label>
              <validacion />
              <b-form-radio v-model="filtro.quincena" name="quincena" value="1" :required="this.filtro.periodo === '1' && this.filtro.quincena == null">Primera</b-form-radio>
              <b-form-radio v-model="filtro.quincena" name="quincena" value="2" :required="this.filtro.periodo === '1' && this.filtro.quincena == null">Segunda</b-form-radio>
              <b-form-invalid-feedback :state="filtro.quincena != null">
                Se debe seleccionar la quincena
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
            <b-form-group align="left">
              <label></label>
              <b-button :disabled="spinner"  type="submit" variant="outline-primary">
                <b-spinner small v-if="spinner"></b-spinner>
                Buscar
              </b-button>
            </b-form-group>

        </div>
      </div>
    </b-form>
    <!--   --------------------------------------------------------------------------------------------------------------------------------------- -->
  </b-container>
</template>

<script>
export default {
  name: "FiltrosBusqueda",
  props: {
    empleados: Array,
    tipoBusqueda: String,
    comisionesBloque: Boolean,
    mostrarFiltroTodos: {
        type: Boolean,
        default: true,
    }
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    spinner: false,
    busqueda: false,
    filtro: {
      idClinica: null,
      idEmpleado: null,
      periodo: null,
      anio: null,
      mes: null,
      quincena: null,
      todosEmpleados: false,
      comisionesBloque: false
    },
    idClinica: null,
    anios: [],
    meses: [
      {value: null, text: "Seleccionar mes"},
      {value: '01', text: "Enero"},
      {value: '02', text: "Febrero"},
      {value: '03', text: "Marzo"},
      {value: '04', text: "Abril"},
      {value: '05', text: "Mayo"},
      {value: '06', text: "Junio"},
      {value: '07', text: "Julio"},
      {value: '08', text: "Agosto"},
      {value: '09', text: "Septiembre"},
      {value: '10', text: "Octubre"},
      {value: '11', text: "Noviembre"},
      {value: '12', text: "Diciembre"},
    ],
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.empleados;
    this.llenarAños()
    this.idClinica = this.$localStorageService.getIdClinica();
  },
  methods:{
    seleccionarOpcion() {
      this.$emit("buscar", this.filtro)
    },
    llenarAños(){
      let inicio = 2021;
      this.anios.push({ value: null, text: 'Seleccionar año' })
      while (inicio <= new Date().getFullYear() +1 ){
        this.anios.push(inicio);
        inicio++
      }
    },
    buscar() {
      if (this.comisionesBloque !== undefined) {
        this.filtro.comisionesBloque = this.comisionesBloque;
      }
      if (this.filtro.idEmpleado == null ){
        this.filtro.idEmpleado = this.$localStorageService.getIdEmpleado();
      }
      this.spinner = true;
      this.busqueda = false;
      if (this.filtro.periodo === '1') {
        if (this.filtro.quincena === '1') {
          this.filtro.idClinica = this.idClinica;
          this.filtro.fechaInicio = this.$moment(this.filtro.anio+"-"+this.filtro.mes+"-01").utc();
          this.filtro.fechaFin = this.$moment(this.filtro.anio+"-"+this.filtro.mes+"-15").utc();
        } else {
          this.filtro.idClinica = this.idClinica;
          this.filtro.fechaInicio = this.$moment(this.filtro.anio+"-"+this.filtro.mes+"-16").utc();
          this.filtro.fechaFin = this.$moment(this.filtro.anio+"-"+this.filtro.mes+"-01").add(1, "month").add(-1, "day").utc();
        }
      } else {
        this.filtro.idClinica = this.idClinica;
        this.filtro.fechaInicio = this.$moment(this.filtro.anio+"-"+this.filtro.mes+"-01").utc();
        this.filtro.fechaFin = this.$moment(this.filtro.anio+"-"+this.filtro.mes+"-01").add(1, "month").add(-1, "day").utc();
      }

      setTimeout(() => {
        this.busqueda = true;
        this.spinner = false;
      }, 500)

      this.$emit("buscar", this.filtro)
    }


  }
}
</script>

<style scoped>

</style>